import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ISolutionHistory } from '@ebb-v2/ebb-integration';

@Injectable({
  providedIn: 'root'
})
export abstract class SolutionHistoryApiService {
  abstract getSolutionHistoryList(): Observable<ISolutionHistory[]>;
}
